import React from 'react';

import { Row, Col } from 'antd';

const items = [
  {
    key: '1',
    icon: <i className="fas fa-book"></i>,
    title: <a style={{color:'grey'}} target='blank' href='./Documentation'>Documentation</a>,
    content: "Read the developer's guide to the C-Pay API to get started on your integration",
  },
  {
    key: '2',
    icon:  <i className="fas fa-server"></i>,
    title: <a style={{color:'green'}} target='blank' href={process.env.REACT_APP_BASE_URL}>API Sandbox</a>,
    content: 'Find the specific information about the different features of the C-Pay API',
  },
  {
    key: '3',
    icon: <i className="fas fa-comments"></i>,
    title: 'Support',
    content: 'Access the C-Pay API community and support team to ensure your success',
  },
]

function AppAbout() {
  return (
    <div id="about" className="block aboutBlock">
      <div className="container-fluid">
        <div className="titleHolder">
          <h2>Choose C-Pay API</h2>
        </div>
        <Row gutter={[16, 16]}>   
          {items.map(item => {
            return (
              <Col md={{ span: 8 }} key={item.key}>
                <div className="content">
                  <div className="icon">
                    {item.icon}
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.content}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
}

export default AppAbout;